<template>
  <div class="newsbox">
    <div class="blank"></div>
    <div class="newkv">
      <swiper :options="swiperOption" ref="mySwiper" class="newswiper">
        <swiper-slide v-for="(item, index) in homelist" :key="index">
          <div class="swiper" @click="toNewDetail(item.id)">
            <!-- <div class="pic"><img :src="item.image+'?x-oss-process=image/resize,m_fixed,w_1920'" width="100%" :alt="item.image_alt"></div> -->
            <!-- <div class="csimg"  :style="{backgroundImage:'url(/static/img/in/kv.jpg)'}"></div>              -->
            <div
              class="cspic"
              :style="{
                backgroundImage:
                  'url(' +
                  item.image +
                  '?x-oss-process=image/resize,m_fixed,w_1920)'
              }"
            ></div>
            <div class="switips">
              <div class="wtbox">
                <div class="swititle">{{ item.date }}</div>
                <div class="swicontent">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div
        class="prev"
        :class="{ pnactive: index != 0 }"
        @click="pre"
        style="color:#fff"
      ></div>
      <div
        class="next"
        :class="{ pnactive: index != hlength }"
        @click="next"
        style="color:#fff"
      ></div>
    </div>
    <div class="news">
      <div class="newlist">
        <div
          class="new"
          :class="{ newno: !newlist.cover_img }"
          v-for="(newlist, index) in newlists"
          :key="index"
          @click="toNewDetail(newlist.id)"
        >
          <!-- <div class="nimg" :class="{nimgno:!newlist.cover_img}" :alt="newlist.image_alt"><img :src="newlist.cover_img"  ></div> -->
          <div
            class="csimg"
            :class="{ nimgno: !newlist.cover_img }"
            :style="{
              backgroundImage:
                'url(' +
                newlist.cover_img +
                '?x-oss-process=image/resize,m_fixed,w_640)'
            }"
          ></div>
          <div class="ncf ndate">{{ newlist.publish_at }}</div>
          <div class="ntitle" :class="{ ntitleno: !newlist.cover_img }">
            {{ newlist.title }}
          </div>
          <div class="ncf ncontent" :class="{ ncontentno: !newlist.cover_img }">
            {{ newlist.about }}
          </div>
        </div>
      </div>
      <div class="more" v-show="activeisload">
        <span class="formore">探索更多</span>
      </div>
      <div class="more" v-show="!activeisload">
        更多精彩资讯，请扫描网页底部二维码关注蓝鲨
      </div>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import utils from '@/utils/index.js'
export default {
  data() {
    const that = this
    return {
      index: 0,
      page: 1,
      hlength: 0, //新闻数目
      pagesize: 12,
      homelist: [],
      newlists: [],
      oneload: true, //一次加载是不是一定完成
      activeisload: true, //是否还有更多数据
      swiperOption: {
        resistanceRatio: 0,
        autoplay: true,
        on: {
          transitionEnd: function() {
            that.index = this.activeIndex
          }
        }
      }
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  mounted() {
    let that = this
    window.scrollTo(0, 0)
    this.$nextTick(function() {
      window.addEventListener('scroll', that.animateTxt)
    })
    this.$nextTick(function() {
      window.addEventListener('scroll', this.handleScroll)
    })
    this.getNews()
    this.oneload = false
    this.getNewLists()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.animateTxt)
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    animateTxt() {
      let top =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset
      if (top <= 100) {
        this.$emit('hidenav')
      } else {
        this.$emit('shownav')
      }
    },
    toNewDetail(id) {
      // this.$router.push({path:`/newsdetail/${id}`})
      this.$router.push('/cn/newsdetail/' + id)
    },
    pre() {
      this.swiper.slidePrev()
    },
    next() {
      this.swiper.slideNext()
    },
    getNews() {
      // let that = this
      this.$source
        .post('/web/api/v1/article/homepage', {
          language: this.GLOBAL.language.chinese
        })
        .then(res => {
          if (res.data.state == 0) {
            let homelist = res.data.data
            let hlength = homelist.length - 1
            homelist.forEach((value, index) => {
              value.date = utils.getDate(value.date)
              value.content = utils.dealArticle(value.content)
            })
            this.homelist = homelist
            this.hlength = hlength
          }
        })
    },
    getNewLists() {
      // let that = this
      this.$source
        .post('/web/api/v1/article/list', {
          page: this.page,
          page_size: this.pagesize,
          language: this.GLOBAL.language.chinese
        })
        .then(res => {
          if (res.data.state == 0) {
            let newlists = res.data.data.list
            if (!newlists || (newlists && newlists.length < this.pagesize)) {
              this.activeisload = false
            } else {
              this.page++
              this.oneload = true
            }
            if (!newlists) return
            newlists.forEach((value, index) => {
              value.publish_at = utils.getDate(value.publish_at)
            })
            this.newlists = this.newlists.concat(newlists)
          }
        })
    },
    handleScroll() {
      if (this.activeisload) {
        //变量scrollTop是滚动条滚动时，距离顶部的距离
        var scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop
        //变量windowHeight是可视区的高度
        var windowHeight =
          document.documentElement.clientHeight || document.body.clientHeight
        //变量scrollHeight是滚动条的总高度
        var scrollHeight =
          document.documentElement.scrollHeight || document.body.scrollHeight
        // console.log(scrollTop,windowHeight,scrollHeight)
        //滚动条到底部的条件
        if (scrollHeight - scrollTop - windowHeight < 200 && this.oneload) {
          // 加载的列表数据
          this.oneload = false
          this.getNewLists()
        } else {
          // console.log("已加载完所有已收藏的商品");
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import '../../assets/css/common.less';
.newsbox {
  .blank {
    height: 60px;
    background: #000;
  }
  .newkv {
    position: relative;
    .newswiper {
      position: relative;
      cursor: pointer;
      .cspic {
        height: 37.5vw;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
      }
      .switips {
        position: absolute;
        width: 100%;
        color: #fff;
        bottom: 10%;
        display: flex;
        justify-content: center;
        .wtbox {
          width: 660px;
          .swititle {
            font-size: 12px;
            margin-bottom: 10px;
          }
          .swicontent {
            font-size: 24px;
          }
        }
      }
    }
    .prev {
      position: absolute;
      background-size: 100%;
      width: 30px;
      height: 30px;
      bottom: 10%;
      margin-top: 12px;
      left: 70px;
      z-index: 1;
    }
    .pnactive {
      background-image: url('/static/img/buttonbg.png');
      cursor: pointer;
    }
    .next {
      position: absolute;
      background-size: 100%;
      width: 30px;
      height: 30px;
      bottom: 10%;
      margin-top: 12px;
      right: 70px;
      z-index: 1;
    }
    .prev::before {
      content: '';
      position: absolute;
      width: 7px;
      height: 11px;
      top: 10px;
      left: 10px;
      background: url('/static/img/prebtn.png') no-repeat;
      background-size: 100% 100%;
    }
    .next::before {
      content: '';
      position: absolute;
      width: 7px;
      height: 11px;
      top: 10px;
      right: 10px;
      background: url('/static/img/nextbtn.png') no-repeat;
      background-size: 100% 100%;
    }
  }

  .news {
    padding: 5vw 0;
    width: 66.67%;
    margin: 0 auto;
    background: #fff;
    .newlist {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 33px;
      border-bottom: 1px solid rgba(229, 229, 229, 1);
      .new {
        width: 30%;
        margin-bottom: 33px;
        box-sizing: border-box;
        &:nth-child(3n-1) {
          margin-left: 5%;
          margin-right: 5%;
        }
        cursor: pointer;
        // .nimg{
        //   margin-bottom:18px;
        //   // height: 160px;
        //   overflow: hidden;
        //   img{
        //     width: 100%;
        //   }
        // }
        .csimg {
          height: 11.12vw;
          margin-bottom: 18px;
          // background-image:url(/static/img/in/kv.jpg) ;
          background-repeat: no-repeat;
          background-position: center;
          background-size: cover;
        }
        .nimgno {
          margin-bottom: 0;
          height: 0;
        }
        .ncf {
          font-size: 14px;
          color: #666;
        }
        .ncontent {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          line-height: 24px;
        }
        .ncontentno {
          -webkit-line-clamp: 5;
        }
        .ntitle {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          margin: 10px 0;
          line-height: 30px;
          height: 60px;
          font-size: 20px;
        }
        .ntitle:hover {
          color: @colorblue;
        }
        .ntitleno {
          -webkit-line-clamp: 3;
          height: auto;
        }
      }
      .newno {
        background: #f2f2f2;
        padding: 3.75%;
      }
    }
    .more {
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 16px;
      color: #666666;
      position: relative;
      .formore:after {
        position: absolute;
        top: 30px;
        left: 50%;
        margin-left: -5px;
        content: '';
        width: 8px;
        height: 8px;
        border-right: 1px solid #666;
        border-bottom: 1px solid #666;
        transform: rotate(45deg);
      }
    }
    .ormore {
      display: flex;
      align-items: center;
      color: #666666;
      font-size: 12px;
      height: 20px;
      line-height: 20px;
      .arrow {
        margin-left: 12px;
        width: 8px;
        height: 8px;
        border-top: 1px solid #666;
        border-right: 1px solid #666;
        transform: rotate(45deg);
      }
    }
  }
}
.newsbox img {
  display: block;
}
@media screen and (max-width: 1640px) {
  .news {
    width: 1080px !important;
  }
  .csimg {
    height: 182px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cn/news.vue